import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams, TenderIdParams } from 'types/api'
import { ITenderCommission } from 'types/tender/tenderCommissions'

export const tenderCommissionsApi = createApi({
  reducerPath: 'tenderCommissions',
  baseQuery,
  tagTypes: ['TenderCommissions'],
  endpoints: (builder) => ({
    tenderCommissions: builder.query<ITenderCommission, TenderIdParams>({
      query: ({ tenderId }) => ({
        url: '/tender-commissions',
        params: {
          tenderId,
        },
      }),
      providesTags: ['TenderCommissions'],
    }),

    tenderCommission: builder.query<ITenderCommission, IdParams>({
      query: ({ id }) => `/tender-commissions/${id}`,
    }),

    createTenderCommission: builder.mutation<
      ITenderCommission,
      Partial<ITenderCommission>
    >({
      query: (body) => ({
        url: '/tender-commissions',
        body,
        method: 'post',
      }),
      invalidatesTags: ['TenderCommissions'],
    }),

    updateTenderCommission: builder.mutation<
      ITenderCommission,
      Partial<ITenderCommission>
    >({
      query: (body) => ({
        url: `/tender-commissions/${body.id}`,
        body,
        method: 'put',
      }),
    }),

    deleteTenderCommission: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/tender-commissions/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['TenderCommissions'],
    }),

    deleteTenderCommissionMember: builder.mutation<
      void,
      { comissionId: string; memberId: string }
    >({
      query: ({ comissionId, memberId }) => ({
        url: `/tender-commissions/${comissionId}/members/${memberId}`,
        method: 'delete',
      }),
      invalidatesTags: ['TenderCommissions'],
    }),

    assignMemberAsChairman: builder.mutation<
      void,
      { comissionId: string; memberId: string }
    >({
      query: ({ comissionId, memberId }) => ({
        url: `/tender-commissions/${comissionId}/members/${memberId}/assign-chairman`,
        method: 'post',
      }),
      invalidatesTags: ['TenderCommissions'],
    }),
  }),
})

export const {
  useTenderCommissionQuery,
  useTenderCommissionsQuery,
  useUpdateTenderCommissionMutation,
  useCreateTenderCommissionMutation,
  useDeleteTenderCommissionMutation,
  useDeleteTenderCommissionMemberMutation,
  useAssignMemberAsChairmanMutation,
} = tenderCommissionsApi
